import { findMeta } from "@/lib/constants";

export function StatusBadge({ list, value }) {
  const meta = findMeta(list, value);
  return (
    <span
      data-testid={`badge-${value}`}
      className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium"
      style={{ color: meta.color, backgroundColor: meta.bg }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: meta.color }} />
      {meta.label}
    </span>
  );
}
